import * as types from '../constants/ActionTypes'

const initialState = {
  messageType: null,
  message: null
}

export default function toastermsg(state = initialState, action) {
  switch (action.type) {
    case types.DISPLAY_ERROR:
      return {
        ...initialState,
        messageType: 'Error',
        message: action.message
      };
    case types.DISPLAY_WARNING:
      return {
        ...initialState,
        messageType: 'Warning',
        message: action.message
      };
    case types.DISPLAY_SUCCESS:
      return {
        ...initialState,
        messageType: 'Success',
        message: action.message
      };
      case types.DISPLAY_DONE:
        return {
          ...initialState,
          messageType: null,
          message: null
        };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/toastermsg.js